import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdMoreVert, MdDeleteForever } from "react-icons/md";
import { Menu } from "@headlessui/react";

import api from "@/services/api";
import Modal from "@/components/modal";
import Pagination from "@/components/Paginator";
import DebounceInput from "@/components/DebounceInput";

const ListSources = () => {
  const [totalActive, setTotalActive] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [sourcesActive, setSourcesActive] = useState([]);
  const [sourcesPending, setSourcesPending] = useState([]);
  const [filter, setFilter] = useState({ search: "", page: 1, pageSize: 100 });

  useEffect(() => {
    loadSources(true);
    loadSources(false);
  }, [filter]);

  async function loadSources(isActive) {
    try {
      const { ok, data, total } = await api.post("/mission_ao_source/search", { ...filter, active: isActive });
      if (!ok) return console.error("Error fetching sources");

      if (isActive) {
        setSourcesActive(data);
        setTotalActive(total);
      } else {
        setSourcesPending(data);
        setTotalPending(total);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function formatDate(dateStr) {
    return dateStr ? new Date(dateStr).toLocaleString() : "";
  }

  function getStatusClass(status) {
    if (status === "Completed") return "bg-green-100 text-green-800";
    if (status === "Failed") return "bg-red-100 text-red-800";
    if (status === "In progress") return "bg-yellow-100 text-yellow-800";
    return "bg-gray-100 text-gray-800";
  }

  function renderTable(title, sources, showScrappedAt) {
    return (
      <div className="mt-6">
        <h2 className="text-lg font-semibold mb-3">{title}</h2>
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow-md overflow-hidden">
            <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-600">
              <tr>
                <th className="px-6 py-3">Name</th>
                <th className="px-6 py-3">Status</th>
                <th className="px-6 py-3">URL</th>
                <th className="px-6 py-3">Comment</th>
                {showScrappedAt && <th className="px-6 py-3">Scrapped At</th>}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {sources.map((source) => (
                <tr key={source._id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-800">{source.name}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClass(source.scrapped_status)}`}>{source.scrapped_status}</span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-800">
                    <a href={source.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                      {source.url}
                    </a>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-800">{source.comment}</td>
                  {showScrappedAt && <td className="px-6 py-4 text-sm text-gray-800">{formatDate(source.scrapped_at)}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <div className="flex flex-1 items-center gap-4 justify-between mb-3">
        <DebounceInput debounce={300} value={filter.search} onChange={(e) => setFilter({ ...filter, search: e.target.value })} className="input" placeholder="Search sources" />
      </div>
      {renderTable("Active Sources", sourcesActive, true)}
      {renderTable("Pending Sources", sourcesPending, false)}
      <div className="flex w-full mt-5">
        <Pagination page={filter.page} setPage={(page) => setFilter({ ...filter, page })} last={Math.ceil((totalActive + totalPending) / filter.pageSize)} />
      </div>
    </div>
  );
};

export default ListSources;
